<template>
    <tr @click="openDpp" :disabled="isCurrent">
        <td>
            <template v-if="isCurrent">
                <i :class="item.propertyTypeIcon" class="f4 text-front"></i>
            </template>
            <template v-else>
                <a @click.stop="removeItem" role="button"><i class="icon-times"></i></a>
            </template>
        </td>
        <td>
            <img class="table-photo" loading="lazy" :alt="item.geo.address" :src= "item.tnImgPath" v-if="item.photoCount > 0 || !isCurrent">
            <mvtMapStatic class="table-photo" :cacheFirst="true" :lat="item.geo.lat" :lng="item.geo.lng" type="streetview" streetViewDefautType="satellite" :address="item.geo.fullAddress"  width="70"  height="70" v-else></mvtMapStatic>
        </td>
        <td>
            <span v-if="!item.hidePrice">{{$filters.formatFriendlyPrice(item.price)}}</span>
            <span v-else>—</span>
        </td>
        <td v-show="!compareWithLand">
            <span v-if="item.bed">
                {{ item.bed }}
            </span>
            <span v-else>—</span>
        </td>
        <td v-show="!compareWithLand">
            <span v-if="item.bath">
                {{ item.bath }}
            </span>
            <span v-else>—</span>
        </td>
        <td v-show="!compareWithLand">
            <span>
                {{ $filters.formatArea(item.sqftTotal, false)}} ft<sup>2</sup>
            </span>
        </td>
        <td>
            <span v-if="!item.hidePrice">
                {{$filters.formatPricePerArea(item.pricePerArea, item.isLand)}}
            </span>
            <span v-else>—</span>
        </td>
        <td v-show="!compareWithLand">
            <span>{{item.yearBuilt}}</span>
        </td>
        <td v-if="item.isCondo">
            <span>
                {{$filters.formatPrice(item.hoafee)}}
            </span>
        </td>
        <td v-else>
            <span v-if="item.lotSize" v-html="$filters.formatFriendlyLotSize(item.lotSize, item.lotSizeUnit, true, ' ft<sup>2</sup>', ' Acre')"></span>
            <span v-else>—</span>
        </td>
        <td class="col-status">
            <span data-allow-mismatch="text" v-if="item.isActive && item.createTimeDisplay">
              {{item.createTimeDisplay}}
            </span>
            <span data-allow-mismatch="text" v-else-if="item.isSold">
                {{$filters.formatDate(item.soldDate)}}
            </span>
        </td>
        <td>
            <span>{{item.distance || 0}} Mi</span>
        </td>
        <td>
            <span>
                {{item.geo.address}}, {{item.geo.zipcode}}
            </span>
        </td>
        <td>
            <img class="table-logo" alt="mls logo" v-if="item.mlsLogoSrc" loading="lazy" :src="item.mlsLogoSrc">
        </td>
    </tr>
</template>
<script src="./mvt-estpriceitem.js"></script>